import axios, { AxiosResponse } from 'axios';
import * as APIConstant from '../constants/apiEndpoint';

export const getParentApi = async (): Promise<AxiosResponse<any>> => {
  const response = await axios.get(APIConstant.PARENT_LIST_API);
  return response.data;
};

export const getParentDetailApi = async (
  parentId?: string,
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(
    `${APIConstant.PARENT_DETAIL_API}/${parentId}`,
  );
  return response.data;
};

export const getChildrenDetailApi = async (
  parentId?: string,
  childId?: string,
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(
    `${APIConstant.CHILD_DETAIL_API}/${parentId}/children/${childId}`,
  );
  return response.data;
};

export const updateParentApi = async (
  params: any,
  parentId?: string,
): Promise<AxiosResponse<any>> => {
  const response = await axios.put(
    `${APIConstant.UPDATE_PARENT_API}/${parentId}`,
    params,
  );
  return response.data;
};

export const sendCustomMessageApi = async (
  params: any,
): Promise<AxiosResponse<any>> => {
  const response = await axios.post(
    APIConstant.SEND_CUSTOM_MESSAGE_API,
    params,
  );
  return response.data;
};

export const deleteParent = async (
  parentId: string,
): Promise<AxiosResponse<any>> => {
  const response = await axios.delete(
    `${APIConstant.DELETE_PARENT_API}/${parentId}`,
  );
  return response.data;
};

export const updateChildApi = async (
  childId: string,
  parentId: string,
  params: any,
): Promise<AxiosResponse<any>> => {
  const response = await axios.put(
    `${APIConstant.UPDATE_CHILD_API}/${parentId}/children/${childId}`,
    params,
  );
  return response.data;
};

export const deleteChildApi = async (
  parentId?: string,
  childId?: string,
): Promise<AxiosResponse<any>> => {
  const response = await axios.delete(
    `${APIConstant.DELETE_CHILD_API}/${parentId}/children/${childId}`,
  );
  return response.data;
};

export const getLogEntriesApi = async (
  offset: number,
  limit: number,
  startDate: string,
  endDate: string,
  parentId?: string,
  childId?: string,
  giftCardId?: string,
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${APIConstant.GET_LOG_API}`, {
    params: {
      offset,
      limit,
      startDate,
      endDate,
      ...(parentId && { parentId }),
      ...(childId && { childId }),
      ...(giftCardId && { giftCardId }),
    },
  });
  return response.data;
};

export const getGiftApi = async (
  offset: number,
  limit: number,
  parentId?: string,
  childId?: string,
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(APIConstant.GET_GIFT_API, {
    params: {
      offset,
      limit,
      ...(parentId && { parentId }),
      ...(childId && { childId }),
    },
  });
  return response.data;
};

export const getCurrentGiftApi = async (
  giftId: string,
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${APIConstant.GET_GIFT_API}/${giftId}`);
  return response.data;
};

export const getAllAdminApi = async (): Promise<AxiosResponse<any>> => {
  const response = await axios.get(APIConstant.GET_ADMIN_USERS_API);
  return response.data;
};

export const createAdminApi = async (
  params: any,
): Promise<AxiosResponse<any>> => {
  const response = await axios.post(APIConstant.CREATE_ADMIN_USER, params);
  return response.data;
};

export const getAdminDetailApi = async (
  userId: string,
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${APIConstant.GET_ADMIN_DETAIL}/${userId}`);
  return response.data;
};

export const deleteAdminApi = async (
  userId: string,
): Promise<AxiosResponse<any>> => {
  const response = await axios.delete(
    `${APIConstant.GET_ADMIN_DETAIL}/${userId}`,
  );
  return response.data;
};

export const updateAdminApi = async (
  userId: string,
  params: any,
): Promise<AxiosResponse<any>> => {
  const response = await axios.patch(
    `${APIConstant.UPDATE_ADMIN}/${userId}`,
    params,
  );
  return response.data;
};
